import { RouterConfiguration, Router, RouteConfig } from 'aurelia-router';
import { bindable, autoinject, observable, computedFrom } from 'aurelia-framework';
import * as Dto from '_models/dtos';
import { DialogService } from 'aurelia-dialog';
import { RegionsDialog } from '_controls/regions-dialog';
import { SessionData } from '_models/session-data';
import { UrlService } from '_services/url-service';


@autoinject
export class TopNav {

    constructor(
        private _dialogSvc: DialogService,
        private _url: UrlService = new UrlService(),
        public sd: SessionData
    ) { 
    }

    attached() {
        if (this.sd.region == null) {

            // Ensure that the user starts here, regardless of the url they entered
            // (in other words, do not allow them to start at the project-schedule with no products added)
            this.navigateHome();

            // Force / prompt user to select a region
            this._dialogSvc.open({
                viewModel: RegionsDialog
            });
        }
    }

    navigateHome() {
        var url = this._url.build('~/product-selector');
        this.router.navigate(url);
    }
        
    @bindable router: Router = null;
}
